module.exports = function getResource(label, vars = []) {
    const resources = {
        found: 'We found your',
        color: 'Color:',
        sorry: 'Sorry, we weren’t able to find a match for you.',
        reviewShades: 'Continue to review available shades for',
        selectShade: 'Select this shade',
        done: 'Done',
        closest: 'closest match',
        exact: 'exact match',
        seeAllProducts: 'See all products in this shade',
        foundMultiShade: 'We found your shade',
        products: 'products',
        serverErrorMessage: 'Uh oh, something went wrong.',
        serverErrorAction: 'Click above to find your shade again.',
        apiErrorMessage: 'Looks like we couldn’t find any results…',
        apiErrorAction: 'Please click above to find your shade again.',
        queryParamsErrorMessage: 'Welcome to Shade Finder',
        queryParamsErrorAction: 'Click above to find your matching foundation.',
        saveBeautyPrefsModalTitle: 'Save to your Beauty Preference',
        saveBeautyPrefsModalMessage: 'Would you like to save this shade to your Beauty Preferences?',
        saveBeautyPrefsModalButton: 'Save',
        saveBeautyPrefsModalButtonSignIn: 'Sign In to Save',
        saveBeautyPrefsModalCancelButton: 'Don’t Save',
        yourBeautyPrefsModalTitle: 'Your Beauty Preferences',
        yourBeautyPrefsModalMessage: 'We’ve made it easy for you! Now you can shop with personalized saved filters.',
        yourBeautyPrefsModalButton: 'Got It',
        yourBeautyPrefsModalCancelButton: 'Edit Beauty Preferences',
        beautyPrefsSavedModalTitle: 'Beauty Preferences Saved',
        beautyPrefsSavedModalMessage: 'Your preferences have been saved.',
        beautyPrefsSavedModalButton: 'Got It',
        beautyPrefsSavedModalCancelButton: 'Edit Beauty Preferences',
        beautyPrefsSaveErrorModalTitle: 'Changes Not Saved',
        beautyPrefsSaveErrorModalMessage: 'Oops, something went wrong while trying to process your submission. Please try again.',
        beautyPrefsSaveErrorModalButton: 'Try Again'
    };

    return resources[label];
};
